import React, { useState, useEffect, useRef } from 'react';

import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

const SatSelect = props => {
  const {
    title = '',
    label = '',
    value,
    valueLabel,
    initOption = null,
    options = [],
    border = false,
    size = 'middle',
    disabled = false,
    readOnly = false,
    isPortal = true,
    width,
    name = 'radio',
    customStyleClass = '',
    validRule = [],
    render,
    onChange,
    isAutoFocus = false,
  } = props;

  const [showSelectModal, setShowSelectModal] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);

  const selectListRef = useRef();
  const selectRef = useRef([]);
  const inputRef = useRef([]);

  const [validErr, setValidErr] = useState({
    visible: false,
    errMsg: '',
    type: 'error',
  });

  useEffect(() => {
    if (validRule.length > 0) {
      if (validRule.find(rule => rule.required)) {
        const { errMsg = '' } = validRule.find(rule => rule.required);
        setValidErr({ visible: true, errMsg: errMsg, type: 'error' });
      } else {
        const [result] = validRule
          .map(rule => {
            return {
              result: rule.rule(value),
              errMsg: rule.errMsg,
            };
          })
          .filter(valid => !valid.result);

        if (result) {
          setValidErr({
            visible: true,
            errMsg: result.errMsg || '',
            type: 'error',
          });
        } else {
          setValidErr({ visible: false, errMsg: '', type: 'error' });
        }
      }
    }
  }, [value]);

  useEffect(() => {
    if (initOption) {
      const { useOption = true, label = '', value = '' } = initOption;
      if (useOption && label !== '') {
        setSelectOptions([{ label, value }].concat(options));
      } else {
        setSelectOptions(options);
      }
    } else {
      setSelectOptions(options);
    }
  }, [options, initOption]);

  useEffect(() => {
    return () => {
      selectListRef.current = null;
      selectRef.current = [];
      inputRef.current = [];
    };
  }, []);

  const handleShowSelectModal = () => {
    if (!disabled) {
      if (!readOnly && (options.length > 1 || value === '')) {
        setShowSelectModal(true);

        if (isAutoFocus) {
          setTimeout(() => {
            const optionIndex = options.findIndex(option => {
              return option.value === value;
            });

            if (optionIndex > -1 && selectRef.current[optionIndex]) {
              selectListRef.current.scrollTo({
                top:
                  selectRef.current[optionIndex].offsetTop -
                  selectRef.current[optionIndex].clientHeight,
              });
              inputRef.current[optionIndex].focus();
            }
          }, 300);
        }
      }
    }
  };

  const handleMobilSelect = option => {
    if (!option.disabled) {
      setShowSelectModal(false);
      if (option.value !== value) {
        setTimeout(() => onChange(option), 200);
      }
    }
  };

  const getSelectedItem = selectedValue => {
    if (selectedValue === '') {
      return initOption ? initOption.label : '선택';
    } else {
      const findItem = options.find(option => option.value === selectedValue);
      if (findItem) {
        return valueLabel
          ? findItem.value
          : findItem.selectedLabel || findItem.label;
      } else {
        return '';
      }
    }
  };

  const selectWrapClass = () => {
    let className = 'input-wrap';

    if (!border) className += ' u-line';
    if (showSelectModal) className += ' focus';
    if (disabled) className += ' disabled';
    if (value !== '' || label !== '') className += ' val';
    if (size === 'small') className += ' small';
    if (readOnly || (options.length === 1 && value !== ''))
      className += ' readonly';
    if (customStyleClass) className += ` ${customStyleClass}`;
    if (validErr.visible) className += ` ${validErr.type}`;

    return className;
  };

  const spanWrapClass = () => {
    let className = 'txt-box';

    if (label === '') className += ' line1';
    return className;
  };

  return (
    <React.Fragment>
      {typeof render === 'function' ? (
        render(handleShowSelectModal)
      ) : (
        <div
          className={selectWrapClass()}
          style={{ width: width }}
          onClick={handleShowSelectModal}
        >
          <div className="input-area">
            {label !== '' && <label className="input-tit">{label}</label>}
            <span className={spanWrapClass()}>{getSelectedItem(value)}</span>
          </div>
          {!readOnly && (
            <SatButton
              styleClass="ico ico-arrow-down"
              onClick={handleShowSelectModal}
            />
          )}
        </div>
      )}

      {validErr.errMsg !== '' && (
        <SatValidationErrMsg
          visible={validErr.visible}
          type={validErr.type}
          message={validErr.errMsg}
        />
      )}

      <SatModal
        isPortal={isPortal}
        visible={showSelectModal}
        setVisible={() => {
          setShowSelectModal(false);
        }}
        type={'slide'}
      >
        <div className="cont">
          <h3 className="layer-tit2">{title}</h3>
          <ul className="select-list" ref={selectListRef}>
            {selectOptions.map((option, index) => {
              return (
                <li
                  key={index}
                  onClick={() => handleMobilSelect(option)}
                  ref={el => {
                    if (selectRef.current) {
                      selectRef.current[index] = el;
                    }
                  }}
                >
                  <div className="check-wrap type-right">
                    <input
                      ref={el => {
                        if (inputRef.current) {
                          inputRef.current[index] = el;
                        }
                      }}
                      type="radio"
                      name={name}
                      value={option.value}
                      disabled={option.disabled || false}
                      checked={option.value === value}
                      onChange={() => {}}
                    />
                    <label>{option.label}</label>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </SatModal>
    </React.Fragment>
  );
};

export default SatSelect;
